import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialog: {
    [theme.breakpoints.up('md')]: {
      width: 600,
      maxWidth: 600
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  }
}))
